import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import ManagePage from '@/views/ManagePage.vue'
import { oemDomain, updateFavicon } from '@/utils'
import { OemName } from '@/utils/constants'

Vue.use(VueRouter)

export enum RouteName {
  TREATMENT_RESERVATION = 'TreatmentReservation',
  TREATMENT_RESERVATION_COMPLETE = 'TreatmentReservationComplete',
  PRIVACY_POLICY = 'PrivacyPolicy',
  TERMS_OF_SERVICE = 'TermsOfService',
  ERROR = 'Error'
}

const routes: Array<RouteConfig> = [
  {
    path: '*',
    redirect: '/404',
    component: () =>
      import(/* webpackChunkName: '404' */ '@/views/error/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/404',
    component: () =>
      import(/* webpackChunkName: '404' */ '@/views/error/404.vue'),
    meta: { hidden: true, title: '404' }
  },
  {
    path: '/error',
    component: ManagePage,
    children: [
      {
        path: '',
        component: () => import('@/views/error/ErrorPage.vue'),
        props: (route: Route) => ({ error: route.params.error }),
        name: RouteName.ERROR,
        meta: { title: 'error' }
      }
    ]
  },
  {
    path: '/reservation/:medicalBusinessId',
    component: ManagePage,
    props: (route: Route) => ({
      medicalBusinessId: route.params.medicalBusinessId
    }),
    children: [
      {
        path: '',
        component: () =>
          import('@/views/treatment-reservation/TreatmentReservationPage.vue'),
        name: RouteName.TREATMENT_RESERVATION,
        meta: { title: '診察予約' }
      },
      {
        path: 'complete',
        component: () =>
          import(
            '@/views/treatment-reservation/TreatmentReservationCompletePage.vue'
          ),
        name: RouteName.TREATMENT_RESERVATION_COMPLETE,
        meta: { title: '診察予約' }
      }
    ]
  },
  {
    path: '/reservation/:medicalBusinessId/:clinicId/privacy-policy',
    component: ManagePage,
    props: (route: Route) => ({
      medicalBusinessId: route.params.medicalBusinessId,
      clinicId: route.params.clinicId
    }),
    children: [
      {
        path: '',
        component: () => import('@/views/privacy-policy/PrivacyPolicyPage.vue'),
        name: RouteName.PRIVACY_POLICY,
        props: true,
        meta: { title: 'プライバシーポリシー' }
      }
    ]
  },
  {
    path: '/reservation/:medicalBusinessId/:clinicId/terms-of-service',
    component: ManagePage,
    props: (route: Route) => ({
      medicalBusinessId: route.params.medicalBusinessId,
      clinicId: route.params.clinicId
    }),
    children: [
      {
        path: '',
        component: () =>
          import('@/views/terms-of-service/TermsOfServicePage.vue'),
        name: RouteName.TERMS_OF_SERVICE,
        props: true,
        meta: { title: '利用規約' }
      }
    ]
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})
// ナビゲーションガードでタイトルを更新
router.beforeEach((to, from, next) => {
  try {
    const oem = oemDomain()
    updateFavicon(oem)
    if (to && to.meta?.title) {
      document.title = to.meta.title as string
    } else {
      switch (oem) {
        case OemName.WellMedi:
          document.title = 'WellMedi'
          break
        case OemName.Zeromedical:
          document.title = 'Zeromedical'
          break
        default:
          document.title = 'March'
          break
      }
    }
    next()
  } catch (error) {
    console.log(error)
    next()
  }
})

export default router
